import React from 'react'

import { getCountryName, makeRelativeTimeString } from './util.js'

import './HoneyTable.scss'

function HoneyTable({
  titleBefore,
  titleHoney,
  titleAfter,
  fields,
  pagination,
  data,
  dataTransform,
}) {
  if(dataTransform) {
    var transforms = dataTransform;
    if(!Array.isArray(transforms)) {
      transforms = [dataTransform];
    }
    transforms.forEach(t => { data = t(data) });
  }

  return (
    <div className="container block">
      <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
        <span>{titleBefore}</span>
        <span className="honey-text">{titleHoney}</span>
        <span>{titleAfter}</span>
      </h5>
      <div className="table-container honey-round-border honey-table-overflow">
        <table className="table is-fullwidth">
          <thead>
            <tr>
              {fields.map((field, index) => (
                <th key={index}>{formatCollumnName(field)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
              {data.map((ele, index) => (
                <tr key={index}>
                  {fields.map((field, index) => (
                    <td key={index}>{ele[field]}</td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default HoneyTable;

export function makeRelativeTime(data) {
  if(noData(data, "Received")) {
    return [];
  }

  return data.map(entry => ({
    ...entry,
    Received: makeRelativeTimeString(entry.Received, true)
  }));
}

export function makeCountryName(data) {
  if(noData(data, "CountryCode")) {
    return [];
  }

  return data.map(entry => {
    entry.CountryName = getCountryName(entry.CountryCode);
    return entry
  });
}

export function makeTargetService(data) {
  if(noData(data, "TargetService")) {
    return [];
  }

  var targetServicePorts = {
    // Databases
    "3306": "MySQL",
    "5432": "PostgreSQL",
    "7474": "Neo4j",
    "9200": "Elasticsearch",
    "27017": "MongoDB",
    "1433": "MS SQL Server",
    "6379": "Redis",

    // Messaging
    "5672": "RabbitMQ",
    "5555": "ZeroMQ",

    // Web
    "80":  "HTTP",
    "443": "HTTPS",

    // File transfer
    "21":  "FTP",
    "990": "FTPs",

    // SSH
    "22": "SSH",
  };

  return data.map(entry => {
    var port = entry.TargetService;
    if(port in targetServicePorts) {
      entry.TargetService = targetServicePorts[port];
    } else {
      entry.TargetService = port;
    }
    return entry
  });
}

export function formatCollumnName(colName) {
  switch(colName) {
    case "TimestampAttemp": return "Timestamp Attemp";
    case "TargetService": return "Target Service";
    case "CountryName": return "Country Name";
    default: return colName;
  }
}

function noData(data, property_name) {
  return data == null || data === [] || data.length === 0 || !data[0].hasOwnProperty(property_name);
}
